import { Component } from '@angular/core';
import { OutlookSkeletonLineComponent } from './skeleton-line.component';

@Component({
  selector: 'maximizer-outlook-skeleton-card',
  template: `
    <div class="flex p-3 gap-2 bg-max-white justify-between mb-2">
      <div class="w-6">
        <maximizer-outlook-skeleton
          containerClasses="h-6 w-full rounded bg-neutral-20"
          fullWidth="full"
        ></maximizer-outlook-skeleton>
      </div>
      <div class="flex-grow flex flex-col gap-2">
        <maximizer-outlook-skeleton
          containerClasses="h-8 w-full rounded bg-neutral-20"
          fullWidth="full"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-4 w-3/4 rounded bg-neutral-20"
          fullWidth="full"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-4 w-3/4 rounded bg-neutral-20"
          fullWidth="full"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-4 w-1/2 rounded bg-neutral-20"
          fullWidth="full"
        ></maximizer-outlook-skeleton>
        <div class="flex pt-2 w-1/2 items-center">
          <maximizer-outlook-skeleton
            containerClasses="h-6 w-6 rounded-full bg-neutral-20"
            fullWidth="none"
          ></maximizer-outlook-skeleton>
          <maximizer-outlook-skeleton
            containerClasses="h-4 flex-grow w-full rounded bg-neutral-20 ml-2"
            fullWidth="full"
          ></maximizer-outlook-skeleton>
        </div>
      </div>
    </div>
  `,
  imports: [OutlookSkeletonLineComponent],
})
export class OutlookSkeletonCardComponent {}
